import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

const ModalContainer = ({ onLoad, onUnload, children }) => {
  const el = document.createElement('div')

  React.useEffect(() => {
    document.body.appendChild(el)
    el.classList.add('checkcherry__widget')
    el.classList.add('checkcherry__widget__modal__container')

    onLoad(el)

    return () => {
      onUnload()
      document.body.removeChild(el)
    }
  }, [])

  return ReactDOM.createPortal(
    children,
    el
  )
}

export default ModalContainer
